module.exports = __webpack_public_path__ + "static/img/CC BY-NC.3ed8ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC BY-NC.png
// module id = TBGF
// module chunks = 16